import { useContext, createContext } from 'react'

export const CampaignFormContext = createContext(null)

export const useCampaignFormContext = () => {
  return useContext(CampaignFormContext)
}
